import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';

class Stock extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { url, src },
        } = this.props;

        return (
            <div className={styles.stock}>
                <a href={url} target="_blank" rel={rel}>
                    <img src={src} />
                </a>
            </div>
        );
    }
}

export default errorBoundary(Stock);
